ProductReviews = window.ProductReviews ?= {}
ProductReviews.Views ?= {}
ProductReviews.Views.Widget ?= {}

ProductReviews.Views.ReviewCard = require './product_reviews_review_card'
ProductReviews.Views.ReviewRating = require './product_reviews_review_rating'
ProductReviews.Views.Widget.Review = require './product_reviews_widget_review'

class ProductReviews.Views.Widget.ReviewRating
  constructor: ({productReviews}) ->
    {@rootUrl, @locale, @showWidgetReview} = productReviews if productReviews
    return {} unless @rootUrl and @locale and @showWidgetReview

    @fetchProductReviews()

  fetchProductReviews: ->
    @deals = $('figure.deal-card[data-uuid], figure.deal-card-mini[data-uuid]')

    if @deals.length
      csrf = $('meta[name=csrf-token]').attr('content')
      $.ajax
        url: "#{@rootUrl}/product_review_proxy/products.json?locale=#{@locale}&_csrf=#{csrf}"
        type: 'POST'
        contentType: 'application/json'
        data: JSON.stringify @prepareData()
        success: @fetchSuccess

  prepareData: ->
    deal_uuid: @extractDealUuids().join()

  extractDealUuids: ->
    dealUuids = []
    @deals.each ->
      uuid = $(this).data('uuid')
      dealUuids.push(uuid) if uuid.length
    dealUuids

  fetchSuccess: (data) =>
    return unless products = data.products

    @deals.each ->
      $el = $(this)
      uuid = $el.data('uuid')
      params =
        $el: $el
        data: products[uuid]
        uuid: uuid
      (new ProductReviews.Views.Widget.Review params).render() if params.data


module.exports = ProductReviews.Views.Widget.ReviewRating
